module.exports = __webpack_public_path__ + "img/sheep.2ca354dd.svg";